/*
 * Super simple javascript class extension taken from CoffeeScript
 * https://coffeescript.org/#classes
 */
__hasProp = {}.hasOwnProperty,
__extends = function(child, parent)
{
  for (var key in parent)
  {
    if (__hasProp.call(parent, key))
      child[key] = parent[key];
  }
  function ctor()
  {
    this.constructor = child;
  }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor;
  child.__super__ = parent.prototype;
  return child;
};


/*** EXPORTS FROM exports-loader ***/
module.exports = __extends;


//////////////////
// WEBPACK FOOTER
// ./assets/js/libs/extend.js
// module id = 2HwW
// module chunks = 3 4